// extracted by mini-css-extract-plugin
export default {"shimmer":"Checkbox_shimmer__1dH6s","dark_shimmer":"Checkbox_dark_shimmer__hkjKN","checkbox":"Checkbox_checkbox__wNdQ6","checkbox_inner":"Checkbox_checkbox_inner__oT5Ry"};